module.exports = __webpack_public_path__ + "static/media/portafolios.7340f99d.jpg";